import React from 'react';
import Links from '~/compositions/TermsAndPolicy/Links';

export default function AgreementLinks() {
  return (
    <>
      Declaro que li e concordo com os <Links />.
    </>
  );
}
